import {Translation} from "react-i18next";

const ConfigSelectChange = [
    {
        id : "COLUMN_NEW" ,
        type : (
            <Translation>
                {(t, { i18n }) => <span>{t("typeArray.ColumnNew")}</span>}
            </Translation>
        )
    },
    {
        id : "FORMULA" ,
        type : (
            <Translation>
                {(t, { i18n }) => <span>{t("typeArray.formula")}</span>}
            </Translation>
        )
    },
    {
        id : "ROW_NEW" ,
        type : (
            <Translation>
                {(t, { i18n }) => <span>{t("typeArray.RowNew")}</span>}
            </Translation>
        )
    }
]

export default ConfigSelectChange